module.exports = __webpack_public_path__ + "static/media/ljuga.5fe7fd37.mp3";